import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const OvertimeLinechart = ({ chartdata, displaychart, selectedRate }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const { value } = displaychart || {};
  const genderValue = value === "0" ? "both" : Number(value);
  useEffect(() => {
    if (!chartdata || chartdata.length === 0) return;

    const years = chartdata.map((d) => String(d.year || ""));

    // Determine which rate to use
    const rateField = selectedRate ? selectedRate.value : null;
    let maleDataField = "total_male_cases";
    let femaleDataField = "total_female_cases";
    let seriesName = "Cases";

    if (rateField) {
      switch (rateField.toLowerCase()) {
        case "asr":
          maleDataField = "total_male_asr";
          femaleDataField = "total_female_asr";
          seriesName = "ASR";
          break;
        case "cir":
          maleDataField = "total_male_cir";
          femaleDataField = "total_female_cir";
          seriesName = "CIR";
          break;
        case "cases":
        default:
          maleDataField = "total_male_cases";
          femaleDataField = "total_female_cases";
          seriesName = "Cases";
          break;
      }
    }

    let series = [];

    switch (genderValue) {
      case 1:
        series = [
          {
            name: `Male ${seriesName}`,
            data: chartdata.map((d) =>
              seriesName === "Cases"
                ? Math.round(d[maleDataField] || 0)
                : d[maleDataField] || 0,
            ),
          },
        ];
        break;

      case 2:
        series = [
          {
            name: `Female ${seriesName}`,
            data: chartdata.map((d) =>
              seriesName === "Cases"
                ? Math.round(d[femaleDataField] || 0)
                : d[femaleDataField] || 0,
            ),
          },
        ];
        break;

      case "both":
      default:
        series = [
          {
            name: `Male ${seriesName}`,
            data: chartdata.map((d) =>
              seriesName === "Cases"
                ? Math.round(d[maleDataField] || 0)
                : d[maleDataField] || 0,
            ),
          },
          {
            name: `Female ${seriesName}`,
            data: chartdata.map((d) =>
              seriesName === "Cases"
                ? Math.round(d[femaleDataField] || 0)
                : d[femaleDataField] || 0,
            ),
          },
        ];
        break;
    }

    setChartSeries(series);

    // Calculate dynamic min and max values from the data (for y-axis)
    let allValues = [];
    series.forEach((s) => {
      allValues = allValues.concat(s.data);
    });
    const minValue = allValues.length ? Math.min(...allValues) : 0;
    const maxValue = allValues.length ? Math.max(...allValues) : 0;
    const range = maxValue - minValue;
    const padding = range === 0 ? Math.abs(maxValue) * 0.1 || 1 : range * 0.1; // 10% padding or default

    // Dynamic axis title based on gender and seriesName
    let axisTitle = "Cases";
    if (genderValue === "both") axisTitle = `Both ${seriesName}`;
    else if (genderValue === 1) axisTitle = `Male ${seriesName}`;
    else if (genderValue === 2) axisTitle = `Female ${seriesName}`;

    setChartOptions({
      markers: { size: 4 },
      chart: { type: "line" },
      stroke: { curve: "smooth" },
      xaxis: {
        categories: years,
        title: { text: "Year" },
      },
      yaxis: {
        title: { text: axisTitle },
        min: Math.max(0, minValue - padding),
        max: maxValue + padding,
        labels: {
          formatter: function (val) {
            return seriesName === "Cases"
              ? Math.round(val)
              : Number(val).toFixed(2);
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return seriesName === "Cases"
              ? Math.round(val)
              : Number(val) % 1 === 0
                ? Number(val)
                : Number(val).toFixed(2);
          },
        },
      },
      dataLabels: { enabled: false },
      legend: { position: "top" },
    });
  }, [chartdata, genderValue, selectedRate]);

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={400}
        width="100%"
      />
    </div>
  );
};

export default OvertimeLinechart;
